import { environment } from '../../../environments/environment';
import { LANGUAGE_FILE_NAME_SUFFIX, SUPPORTED_LANGUAGE } from '../../constants';
import { ISupportedLanguagePack } from '../models/i-supported-language-pack';

export class LocaleUtils {
    public static getSupportedLanguages(): ISupportedLanguagePack {
        const configSupportedLanguages = environment.supportedLanguages;
        const supportedLanguages: Record<string, SUPPORTED_LANGUAGE> = {};
        const languageFileNameSuffixes: Record<string, string> = {};

        configSupportedLanguages.map((language) => {
            if (language && SUPPORTED_LANGUAGE[language]) {
                if (!supportedLanguages[language]) {
                    supportedLanguages[language] = SUPPORTED_LANGUAGE[language] as SUPPORTED_LANGUAGE;
                }
                if (!languageFileNameSuffixes[language]) {
                    languageFileNameSuffixes[language] = LANGUAGE_FILE_NAME_SUFFIX[SUPPORTED_LANGUAGE[language]];
                }
            }
        });

        if (!Object.keys(supportedLanguages).length) {
            return {
                supportedLanguages: {
                    [SUPPORTED_LANGUAGE.DE_CH]: SUPPORTED_LANGUAGE.DE_CH
                },
                languageFileNameSuffixes: {
                    [SUPPORTED_LANGUAGE.DE_CH]: LANGUAGE_FILE_NAME_SUFFIX[SUPPORTED_LANGUAGE.DE_CH]
                }
            };
        }

        return {
            supportedLanguages,
            languageFileNameSuffixes
        };
    }
}
